export const API_BASE_URL =
    process.env.REACT_APP_AUTH_API_URL ||
    'https://www.bharatvidyarthi.com/backend/api/v1/auth/';
export const USERS_END_POINT={
    ALL_USERS : 'users',
    PHONE_EXISTS: 'users?phoneNumber=',
    EMAIL_EXISTS: 'users?email=',
    GET_LOGIN_RESPONSE: "login",
    GET_SIGNUP_RESPONSE: "signup"

};